import config from 'config';

const getDataFromResponse = (res: Response) => {
  const contentType = res.headers.get('Content-Type')?.split(';')[0];
  if (contentType === 'application/json') return res.json();
  if (contentType && contentType.includes('text')) return res.text();
  return res.blob();
};

export const fetchAsset = (url, signal: AbortSignal | undefined = undefined) =>
  fetch(url, {
    headers:
      config.serverUrl && url.startsWith(config.serverUrl)
        ? {
            'authorization-token':
              localStorage.getItem('authorization-token') || '',
          }
        : undefined,
    signal,
  }).then(async res => {
    const data = await getDataFromResponse(res);
    const localURL = data instanceof Blob ? URL.createObjectURL(data) : '';

    const contentType = res.headers.get('Content-Type');
    let type = 'unknown';
    if (contentType?.startsWith('image')) type = 'image';
    else if (contentType?.startsWith('video')) type = 'video';
    else if (contentType?.startsWith('text')) type = 'text';

    return { type, localURL, data };
  });
